exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.table .grid-filter-th {vertical-align:middle;}\n.table .grid-filter-input {margin-bottom:0;}\r\n", ""]);

